import { Link } from 'react-router-dom';
import styled from 'styled-components';

export default styled(Link)`
  ${props => props}
  color: ${props => props.theme.old.colors[props.color] || props.theme.old.colors.secondary};
  font-family: ${props => props.theme.old.fonts.family[props.family] || props.theme.old.fonts.family.primary};
  font-size: ${props => props.theme.old.fontSize[props.size] || props.theme.old.fontSize.text};
  font-weight: ${props => props.theme.old.fonts.weight[props.weight] || props.theme.old.fonts.weight.semibold};
  transition: ${props => props.theme.old.transition.default};
  cursor: pointer;

  :hover{
    color: ${props => props.theme.old.colors[props.hoverColor] || props.theme.old.colors.primary};
  }
`;